import { OverlayRef } from "@angular/cdk/overlay";
import { EventEmitter } from "@angular/core";
import { MediaViewerConfig } from "./media-viewer-overlay.component";

export class MediaViewerOverlayRef {

  // public viewer: MediaViewerComponent | undefined;
  public onDestroy = new EventEmitter<() => void>();
  public onDestroyed = new EventEmitter<void>();
  public onClose = new EventEmitter<(() => void) | void>();
  public onClosed = new EventEmitter<void>();
  public onOpen = new EventEmitter<(() => void) | void>();
  public onOpened = new EventEmitter<void>();
  public onAction = new EventEmitter<{ action: string, parameter: any }>();

  private _opened = false;

  constructor(private overlayRef: OverlayRef, 
              public config: MediaViewerConfig) { 
  }

  destroy(): void {
    this.onDestroy.emit(() => {
      this._opened = false;
      this.onDestroyed.emit();
      this.overlayRef.dispose();
     });
  }

  close(): void {
    if (!this._opened) {
      this.onClosed.emit();
    }
    this.onClose.emit(() => {
      this._opened = false;
      this.onClosed.emit();
      this.overlayRef.addPanelClass('closed');
    });
  }

  open(): void {
    this.overlayRef.removePanelClass('closed');
    if (this._opened) {
      this.onOpened.emit();
    }
    this.onOpen.emit(() => {
      this._opened = true;
      this.onOpened.emit();
     });
  }

  get opened(): boolean {
    return this._opened;
  }
}
